import { TFunction } from 'i18next';

export const isFieldRequired = (t: TFunction, isRequired?: boolean) => {
  return isRequired ? t('form.isRequired') : false;
};
export default isFieldRequired;
